var collapsible_list_pair_rtlignore_default = {
  "container": "VZX-Q",
  "title": "Z17Cr",
  "viewerContainer": "UipAH",
  "titleContainer": "cuWLM",
  "content": "N9KFy",
  "expandIcon": "qA4zm",
  "dndIcon": "wpeQI",
  "RTL": "LzEA0",
  "LTR": "gD55U",
  "itemContainer": "H-4jD",
  "itemContainerViewer": "xFMfw",
  "mouseDown": "VgNOa",
  "innerEditor": "xN1-3",
  "item": "Zsa0v",
  "floatingAddPluginMenuWrapper": "Ft6GP"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
